/* eslint-disable max-len */
import GOVIcon from '../../../../../assets/governance.png';
import {corporateBusinessStrategyQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/corporateBusinessStrategyQuestions';
import {corporateDisclosureQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/corporateDisclosureQuestions';
import {corporateGovernanceQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/corporateGovernanceQuestions';
import {corporateIntroQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/corporateIntroQuestions';
import {corporateManagementQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/corporateManagementQuestions';
import {corporatePerformanceClimateChangeQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/corporatePerformanceClimateChangeQuestions';
import {corporatePerformanceConsolidationApproachQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/corporatePerformanceConsolidationApproachQuestions';
import {environmentalPerformanceBiodiversityQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/environmentalPerformanceBiodiversityQuestions';
import {environmentalPerformanceFinancialServicesQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/environmentalPerformanceFinancialServicesQuestions';
import {environmentalPerformanceForestsQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/environmentalPerformanceForestQuestions';
import {environmentalPerformancePlasticsQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/environmentalPerformancePlasticsQuestions';
import {environmentalPerformanceWaterSecurityQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/environmentalPerformanceWaterSecurityQuestions';
import {furtherInformationAndSignOffQuestions} from '../../../../../components/Forms/Constants/CDP/corporate/furtherInformationAndSignOffQuestions';
import {getCdpCorporateUrl} from '../utils/utils';

export const pillers = {
  corporateIntroduction: 'pillar_corporate_introduction',
  corporateManagement: 'pillar_corporate_management',
  corporateDisclosure: 'pillar_corporate_disclosure',
  corporateGovernance: 'pillar_corporate_governance',
  corporateStrategy: 'pillar_corporate_strategy',
  corporatePerformanceConsolidationApproach:
    'pillar_corporate_performance_consolidation_approach',
  corporatePerformanceClimateChange:
    'pillar_corporate_performance_climate_change',
  corporateEnvironmentalPerformanceForests:
    'pillar_corporate_environmental_performance_forests',
  corporateEnvironmentalPerformanceWaterSecurity:
    'pillar_corporate_environmental_performance_water_security',
  corporateEnvironmentalPerformancePlastics:
    'pillar_corporate_environmental_performance_plastics',
  corporateEnvironmentalPerformanceBiodiversity:
    'pillar_corporate_environmental_performance_biodiversity',
  corporateEnvironmentalPerformanceFinancialServices:
    'pillar_corporate_environmental_performance_financial_services',
  corporateFurtherInformationAndSignOff:
    'pillar_corporate_further_information_and_sign_off'
};

export const corporateIntroTabQuestions = {
  pillarId: pillers.corporateIntroduction,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Introduction',
    description: `This module requests information about the organization’s disclosure 
      to CDP and will help data users interpret responses in the context of the organization’s 
      business operations, timeframe, and entities included in their CDP response. `,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(pillers.corporateIntroduction),
  tabs: [
    {
      id: 'tab_corporateIntroduction',
      title: 'Corporate Introduction',
      questions: corporateIntroQuestions,
      accordion: false
    }
  ]
};

export const corporateManagementTabQuestions = {
  pillarId: pillers.corporateManagement,
  header: {
    imageUrl: GOVIcon,
    title:
      'Corporate Identification, assessment, and management of dependencies, impacts, risks, and opportunities',
    description:
      'This module requests information about the time horizons at which organizations consider environmental issues, how an organization defines what is a substantive effect on its business, the procedures that organizations have in place to identify, assess and manage their environmentalrelated dependencies, impacts, risks, and opportunities relevant to their sector, and the identification of priority locations.',
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(pillers.corporateManagement),
  tabs: [
    {
      id: 'tab_corporateManagement',
      title:
        'Corporate Identification, assessment, and management of dependencies, impacts, risks, and opportunities',
      questions: corporateManagementQuestions,
      accordion: false
    }
  ]
};

export const corporateDisclosureTabQuestions = {
  pillarId: pillers.corporateDisclosure,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Disclosure of Risks and Opportunities',
    description: `This module allows organizations to demonstrate that they have a clear awareness of the extent to
              which they are exposed to environmental risks, and aligned with environmental opportunities, within
              their direct operations and other parts of their value chain.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(pillers.corporateDisclosure),
  tabs: [
    {
      id: 'tab_corporateDisclosure',
      title: 'Corporate Disclosure of Risks and Opportunities',
      questions: corporateDisclosureQuestions,
      accordion: false
    }
  ]
};

export const corporateGovernanceTabQuestions = {
  pillarId: pillers.corporateGovernance,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Governance',
    description: `This module requests information on the governance structure of your organization 
                    and its governance mechanisms with regards to environmental issues.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(pillers.corporateGovernance),
  tabs: [
    {
      id: 'tab_corporateGovernance',
      title: 'Corporate Governance',
      questions: corporateGovernanceQuestions,
      accordion: false
    }
  ]
};

export const corporateStrategyTabQuestions = {
  pillarId: pillers.corporateStrategy,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Business Strategy',
    description: `CDP data users are interested in organizations’ forward-looking strategies, and financial
                    decisions that are driven by future market opportunities, public policy objectives, and
                    corporate responsibilities related to the environment.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(pillers.corporateStrategy),
  tabs: [
    {
      id: 'tab_corporateStrategy',
      title: 'Corporate Business Strategy',
      questions: corporateBusinessStrategyQuestions,
      accordion: false
    }
  ]
};

export const corporatePerformanceConsolidationApproachTabQuestions = {
  pillarId: pillers.corporatePerformanceConsolidationApproach,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Environmental Performance – Consolidation Approach',
    description: `This module requests information on the method used by organizations to define their reporting
                    boundary for environmental performance data, such as greenhouse gas (GHG) emissions, water withdrawals, forest 
                    impacts, plastics, and biodiversity.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(
    pillers.corporatePerformanceConsolidationApproach
  ),
  tabs: [
    {
      id: 'tab_corporatePerformanceConsolidationApproach',
      title: 'Corporate Environmental Performance -Consolidation Approach',
      questions: corporatePerformanceConsolidationApproachQuestions,
      accordion: false
    }
  ]
};

export const corporatePerformanceClimateChangeTabQuestions = {
  pillarId: pillers.corporatePerformanceClimateChange,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Environmental Performance – Climate Change',
    description: `This module includes questions on emissions methodologies, exclusions, emissions inventory 
                    and breakdown, energy related activities, electricity transmission and distribution, production data and 
                    intensity & efficiency metrics. `,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(pillers.corporatePerformanceClimateChange),
  tabs: [
    {
      id: 'tab_corporatePerformanceClimateChange',
      title: 'Corporate Environmental Performance - Climate Change',
      questions: corporatePerformanceClimateChangeQuestions,
      accordion: false
    }
  ]
};

export const corporateEnvironmentalPerformanceForestsTabQuestions = {
  pillarId: pillers.corporateEnvironmentalPerformanceForests,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Environmental Performance - Forests',
    description: `This module requests information on your organization’s 
                    dependency on commodities, and implementation of policies and commitments 
                    related to deforestation and conversion of other natural ecosystems. `,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(
    pillers.corporateEnvironmentalPerformanceForests
  ),
  tabs: [
    {
      id: 'tab_corporateEnvironmentalPerformanceForests',
      title: 'Corporate Environmental Performance - Forests',
      questions: environmentalPerformanceForestsQuestions,
      accordion: false
    }
  ]
};

export const corporateEnvironmentalPerformanceWaterSecurityTabQuestions = {
  pillarId: pillers.corporateEnvironmentalPerformanceWaterSecurity,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Environmental Performance - Water Security',
    description: `The promotion of water security for all is supported when companies:
          • Reduce their dependency on freshwater sources and track their progress`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(
    pillers.corporateEnvironmentalPerformanceWaterSecurity
  ),
  tabs: [
    {
      id: 'tab_corporateEnvironmentalPerformanceWaterSecurity',
      title: 'Corporate Environmental Performance - Water Security',
      questions: environmentalPerformanceWaterSecurityQuestions,
      accordion: false
    }
  ]
};

export const corporateEnvironmentalPerformancePlasticsTabQuestions = {
  pillarId: pillers.corporateEnvironmentalPerformancePlastics,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Environmental Performance - Plastics',
    description: `Tackling plastic pollution and waste is important for safeguarding our global marine,
          freshwater and terrestrial ecosystems, as well as our economies and communities`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(
    pillers.corporateEnvironmentalPerformancePlastics
  ),
  tabs: [
    {
      id: 'tab_corporateEnvironmentalPerformancePlastics',
      title: 'Corporate Environmental Performance - Plastics',
      questions: environmentalPerformancePlasticsQuestions,
      accordion: false
    }
  ]
};

export const corporateEnvironmentalPerformanceBiodiversityTabQuestions = {
  pillarId: pillers.corporateEnvironmentalPerformanceBiodiversity,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Environmental Performance - Biodiversity',
    description: `Tackling plastic pollution and waste is important for safeguarding our global marine,
          freshwater and terrestrial ecosystems, as well as our economies and communities`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(
    pillers.corporateEnvironmentalPerformanceBiodiversity
  ),
  tabs: [
    {
      id: 'tab_corporateEnvironmentalPerformanceBiodiversity',
      title: 'Corporate Environmental Performance - Biodiversity',
      questions: environmentalPerformanceBiodiversityQuestions,
      accordion: false
    }
  ]
};

export const corporateEnvironmentalPerformanceFinancialServicesTabQuestions = {
  pillarId: pillers.corporateEnvironmentalPerformanceFinancialServices,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Environmental Performance - Financial Services',
    description: `The data disclosed in this module will help with the understanding of the 
           interdependence between biodiversity and business resilience`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(
    pillers.corporateEnvironmentalPerformanceFinancialServices
  ),
  tabs: [
    {
      id: 'tab_corporateEnvironmentalPerformanceFinancialServices',
      title: 'Corporate Environmental Performance - Financial Services',
      questions: environmentalPerformanceFinancialServicesQuestions,
      accordion: false
    }
  ]
};

export const corporateFurtherInformationAndSignOffTabQuestions = {
  pillarId: pillers.corporateFurtherInformationAndSignOff,
  header: {
    imageUrl: GOVIcon,
    title: 'Corporate Further Information And Sign Off',
    description: `Verification and assurance is good practice in environmental 
         reporting as it ensures the quality of data and processes disclosed.`,
    noOfModules: 1,
    answeredQuestions: 1,
    totalQuestions: 1
  },
  APIRoute: getCdpCorporateUrl(pillers.corporateFurtherInformationAndSignOff),
  tabs: [
    {
      id: 'tab_corporateFurtherInformationAndSignOff',
      title: 'Corporate Further Information And Sign Off',
      questions: furtherInformationAndSignOffQuestions,
      accordion: false
    }
  ]
};
